import React, { useState, useRef, useEffect } from 'react';
import styles from '../../../styles/HomeLanding/HomeLanding.module.css';
import Image from 'next/image';
import { Button } from 'reactstrap';
import { QuickWordData } from '@/constants/common';


const QuickWord = () => {
    const [isInView, setIsInView] = useState(false);
    const sectionRef = useRef(null);
    const [visibility, setVisibility] = useState([true, true, true, true]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [clickedIndex, setClickedIndex] = useState(null);
    const [isPlaying, setIsPlaying] = useState([false, false, false, false]);
    const videoRefs = useRef([]);

    useEffect(() => {
        const el = sectionRef.current;
        if (!el || isInView) return;

        const reveal = () => setIsInView(true);

        if (typeof IntersectionObserver === 'undefined') {
            reveal();
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    reveal();
                    observer.disconnect();
                }
            },
            { rootMargin: '200px 0px', threshold: 0 }
        );
        observer.observe(el);

        return () => {
            observer.disconnect();
        };
    }, [isInView]);

    useEffect(() => {
        const handleScroll = () => {
            // Stop all videos when scrolling
            videoRefs.current.forEach((video, index) => {
                if (video && !video.paused) {
                    video.pause();
                    video.currentTime = 0;
                }
            });
            
            // Reset all states
            setVisibility([true, true, true, true]);
            setActiveIndex(null);
            setClickedIndex(null);
            setIsPlaying([false, false, false, false]);
        };

        window.addEventListener('scroll', handleScroll);
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (!isInView) return;

        const initializeVideos = () => {
            videoRefs.current.forEach((video) => {
                if (video) {
                    video.setAttribute('webkit-playsinline', 'true');
                    video.setAttribute('playsinline', 'true');
                    video.muted = true;
                    video.preload = 'metadata';
                    video.load();
                }
            });
        };

        const timer = setTimeout(initializeVideos, 100);

        return () => clearTimeout(timer);
    }, [isInView]);

    const handleClick = (index) => {
        const video = videoRefs.current[index];
        setVisibility(prev => prev.map((v, i) => i === index ? false : v));
        setActiveIndex(index);
        setClickedIndex(index);
        setIsPlaying(prev => prev.map((v, i) => i === index ? true : v));

        if (video) {
            video.src = Content[index].clickVideo;
            video.muted = false;
            video.controls = true;
            video.controlsList = "nodownload nofullscreen noremoteplayback";
            video.disablePictureInPicture = true;  
            video.disableRemotePlayback = true;
            video.loop = false;
            video.preload = "metadata";
            video.setAttribute('webkit-playsinline', 'true');
            video.setAttribute('playsinline', 'true');

            const playVideoOnLoad = () => {
                video.play()
                    .catch(error => {
                        console.error('Error playing the video:', error);
                        video.muted = true;
                        video.play().catch(e => console.error('Fallback play failed:', e));
                    });
                video.removeEventListener('loadeddata', playVideoOnLoad);
            };

            video.addEventListener('loadeddata', playVideoOnLoad);
        }

       
        videoRefs.current.forEach((ref, i) => {
            if (i !== index && ref) {
                setVisibility(prev => prev.map((v, idx) => idx === i ? true : v));
                setIsPlaying(prev => prev.map((v, idx) => idx === i ? false : v));
                ref.pause();
                ref.currentTime = 0;
                ref.src = Content[i].hoverVideo;
                ref.muted = true;
                ref.controls = false;
                ref.setAttribute('webkit-playsinline', 'true');
                ref.setAttribute('playsinline', 'true');
            }
        });
    };

    const Content  = QuickWordData
    const handleMouseEnter = (index) => {
        const video = videoRefs.current[index];
        if (visibility[index]) {
            setVisibility(prev => prev.map((v, i) => i === index ? false : v));
        }
        if (clickedIndex !== index && !isPlaying[index]) {
            if (video && video.paused) {
                video.muted = true;
                video.loop = true;
                video.controls = false;
                video.setAttribute('webkit-playsinline', 'true');
                video.setAttribute('playsinline', 'true');
                video.play().catch(error => {
                    console.error('Error playing hover video:', error);
                    video.load();
                });
            }
        }
        setActiveIndex(index);
    };

    const handleMouseLeave = (index) => {
        const video = videoRefs.current[index];
        if (!visibility[index]) {
            setVisibility(prev => prev.map((v, i) => i === index ? true : v));
        }
        if (!isPlaying[index] && clickedIndex !== index) {
            if (video && !video.paused) {
                video.pause();
                video.currentTime = 0;
            }
        }
        setActiveIndex(null);
    };

    return (
        <div ref={sectionRef}>
            <div className={styles.quickword_title}>
                <div className={styles.header}>Quick Word</div>
                <h4 style={{ fontSize: "2.8rem", fontFamily: "GilroyBold", lineHeight:"4rem" }}> <span style={{ color: "#1264A3" }}>Perfect Fit </span> for Every Business</h4>
            </div>

            <div style={{ position: "relative", display: "flex", gap: "2rem", width: "100%", margin: '-2rem 0 9.5rem 0 ' }}>
                {Content.map((ele, index) => (
                    <div
                        key={index}
                        style={{
                            position: "relative",
                            width: "30rem",
                            borderRadius: "2rem",
                            overflow: "hidden",
                            height: "48rem",
                        }}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={() => handleMouseLeave(index)}
                    >
                        <div style={{ position: "relative", width: "100%", height: "100%", background: "#161747" }}>

                            {!isPlaying[index] && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        zIndex: 1,
                                        cursor: "pointer"
                                    }}

                                />
                            )}
                            {isInView && (
                                <video
                                    ref={el => videoRefs.current[index] = el}
                                    id={`video-${index}`}
                                    src={clickedIndex === index ? ele.clickVideo : ele.hoverVideo}
                                    muted={!(isPlaying[index] || clickedIndex === index)}
                                    controls={isPlaying[index] || clickedIndex === index}
                                    loop={!(isPlaying[index] || clickedIndex === index)}
                                    playsInline
                                    webkit-playsinline="true"
                                    preload="metadata"
                                    disableRemotePlayback
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        zIndex: 0,
                                    }}
                                    onError={(e) => {
                                        console.error('Video error:', e);
                                        const video = e.target;
                                        video.load();
                                    }}
                                    onLoadStart={() => {
                                        const video = videoRefs.current[index];
                                        if (video) {
                                            video.setAttribute('webkit-playsinline', 'true');
                                            video.setAttribute('playsinline', 'true');
                                        }
                                    }}
                                />
                            )}
                        </div>

                        {visibility[index] &&  !isPlaying[index] &&(
                            <div
                                style={{
                                    position: "absolute",
                                    zIndex: 1,
                                    bottom: 0,
                                    color: "white",
                                    padding: "2rem",
                                    backdropFilter: "blur(17px)",
                                    background: "linear-gradient(to bottom, #FEF4E800, #161747 100%)",
                                    width: "100%",
                                    height: "47%",
                                    display: "flex",
                                    flexDirection: "column",
                                    // justifyContent: "space-between",
                                  
                                    // alignItems: "center",
                                }}
                            >
                                {/* <div style={{display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem", width: "100%"}}> */}
                                  <div style={{ position: "relative", height: ele?.height, width: ele?.width, marginBottom: "1rem" }}>
                                    <Image src={ele.icon} alt="icon" fill sizes={ele.width} />
                                  </div>
                                  {/* <div style={{ height:  '3rem', width: '1px', background: '#E0E0E0', margin: '0 0rem' }} /> */}
                                   
                                {/* </div> */}
                                <p style={{fontSize:"1.3rem"}}>{ele.text}</p>
                                <div style={{position: "absolute", bottom: "0.8rem"}}>
                                    <p style={{fontSize:"1.4rem"}}>{ele.name}</p>
                                    <p style={{fontSize:"1rem", marginTop:"-0.9rem"}}>{ele?.designation}</p>
                                  </div>
                                {/* Play Button - Only visible on hover */}
                                <div
                                    className="play-button"

                                    style={{
                                        position: "absolute",
                                        top: "2rem",
                                        right: "2rem",
                                        backgroundColor: "rgba(246, 142, 30, 0.9)",
                                        borderRadius: "2rem",
                                        padding: "0.5rem 1.2rem",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        zIndex: 2,
                                        opacity: 0,
                                        visibility: "hidden",
                                        gap: "0.5rem"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "rgba(246, 142, 30, 1)";
                                        e.currentTarget.style.transform = "scale(1.05)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "rgba(246, 142, 30, 0.9)";
                                        e.currentTarget.style.transform = "scale(1)";
                                    }}
                                >
                                    <span style={{ color: "white", fontWeight: "bold", fontSize: "0.9rem" }}>Play</span>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 5V19L19 12L8 5Z" fill="white" />
                                    </svg>
                                </div>
                            </div>
                        )}

                        {!visibility[index] && !isPlaying[index] && (
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "2rem",
                                    left: 0,
                                    right: 0,
                                    display: "flex",
                                    justifyContent: "center",
                                    zIndex: 3

                                }}
                            >
                                
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    bottom: "2rem",
                                    opacity: 1,
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",

                                    backgroundColor: "#F68E1E",
                                    color: "#fff",
                                    justifyContent: "center",
                                    height: "3rem",
                                    fontSize: "1.3rem",
                                }}>
                                    <Button style={{
                                        borderRadius: "1rem", padding: '0.5rem 2rem', position: "absolute", backgroundColor: "white", color: "black", border: "none", fontFamily: "GilroySemiBold"
                                    }} onClick={() => handleClick(index)} >Play</Button>
                                </div>

                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuickWord;
